// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZakupiteljChoice_wrapper__QAaA5 {
  width: 100%;
  border: 1px solid #cb9c2d;
  border-radius: 8px;
  padding: 15px;
}

.ZakupiteljChoice_container__K8C5d {
  padding: 10px 0px;
}

.ZakupiteljChoice_choice__nXzVE {
  display: flex;
}

.ZakupiteljChoice_title__t1ujb {
  color: #4d4e4e;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 0px 0px 8px;
}

.ZakupiteljChoice_text__YZZ-M {
  color: #6e6e6e;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}

.ZakupiteljChoice_checkCitiesContainer__Mu1kp {
  display: flex;
  flex-direction: column;
  padding: 10px 0px;
}

.ZakupiteljChoice_selectedCitiesContainer__2OnvZ {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 10px 0px;
}

.ZakupiteljChoice_btnsContainer__GodHf {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.ZakupiteljChoice_odustaniButton__fht4j {
  background-color: #ebebeb;
  color: #808080;
  text-transform: capitalize;
}
.ZakupiteljChoice_odustaniButton__fht4j,
.ZakupiteljChoice_submitButton__k98EL {
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  width: 150px;
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
  transition: background-color 300ms ease-in-out;
  border: none;
}
.ZakupiteljChoice_submitButton__k98EL {
  background-color: #cb9c2d;
  color: #ffffff;
}
.ZakupiteljChoice_odustaniButton__fht4j:hover {
  background-color: #d1d0d0;
}
.ZakupiteljChoice_submitButton__k98EL:hover {
  background-color: #ac8427;
}
.ZakupiteljChoice_radioContainer__YUBJS {
  display: flex;
  flex-direction: column;
  padding: 10px 0px;
  gap: 7px;
}

.ZakupiteljChoice_radioInput__z54Ln {
  appearance: none;
  background-color: transparent;
  border: 1px solid #cb9c2d;
  border-radius: 50%;
  cursor: pointer;
  height: 21px;
  margin: 0px;
  padding: 0px;
  position: relative;
  width: 21px;
}
.ZakupiteljChoice_radioInput__z54Ln:checked {
  background-color: transparent;
}
.ZakupiteljChoice_radioInput__z54Ln:checked::before {
  background-color: #cb9c2d;
  border-radius: 64px;
  content: "";
  height: 14px;
  left: 3px;
  position: absolute;
  top: 2.8px;
  width: 14px;
}

.ZakupiteljChoice_radioRowContainer__Mz\\+RO {
  display: flex;
  align-items: center;
  gap: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ZakupiteljChoice/ZakupiteljChoice.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,8CAA8C;EAC9C,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":[".wrapper {\n  width: 100%;\n  border: 1px solid #cb9c2d;\n  border-radius: 8px;\n  padding: 15px;\n}\n\n.container {\n  padding: 10px 0px;\n}\n\n.choice {\n  display: flex;\n}\n\n.title {\n  color: #4d4e4e;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 0px 0px 8px;\n}\n\n.text {\n  color: #6e6e6e;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n\n.checkCitiesContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 0px;\n}\n\n.selectedCitiesContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  padding: 10px 0px;\n}\n\n.btnsContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n}\n\n.odustaniButton {\n  background-color: #ebebeb;\n  color: #808080;\n  text-transform: capitalize;\n}\n.odustaniButton,\n.submitButton {\n  align-items: center;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  width: 150px;\n  font-family: Inter;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  transition: background-color 300ms ease-in-out;\n  border: none;\n}\n.submitButton {\n  background-color: #cb9c2d;\n  color: #ffffff;\n}\n.odustaniButton:hover {\n  background-color: #d1d0d0;\n}\n.submitButton:hover {\n  background-color: #ac8427;\n}\n.radioContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 0px;\n  gap: 7px;\n}\n\n.radioInput {\n  appearance: none;\n  background-color: transparent;\n  border: 1px solid #cb9c2d;\n  border-radius: 50%;\n  cursor: pointer;\n  height: 21px;\n  margin: 0px;\n  padding: 0px;\n  position: relative;\n  width: 21px;\n}\n.radioInput:checked {\n  background-color: transparent;\n}\n.radioInput:checked::before {\n  background-color: #cb9c2d;\n  border-radius: 64px;\n  content: \"\";\n  height: 14px;\n  left: 3px;\n  position: absolute;\n  top: 2.8px;\n  width: 14px;\n}\n\n.radioRowContainer {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ZakupiteljChoice_wrapper__QAaA5`,
	"container": `ZakupiteljChoice_container__K8C5d`,
	"choice": `ZakupiteljChoice_choice__nXzVE`,
	"title": `ZakupiteljChoice_title__t1ujb`,
	"text": `ZakupiteljChoice_text__YZZ-M`,
	"checkCitiesContainer": `ZakupiteljChoice_checkCitiesContainer__Mu1kp`,
	"selectedCitiesContainer": `ZakupiteljChoice_selectedCitiesContainer__2OnvZ`,
	"btnsContainer": `ZakupiteljChoice_btnsContainer__GodHf`,
	"odustaniButton": `ZakupiteljChoice_odustaniButton__fht4j`,
	"submitButton": `ZakupiteljChoice_submitButton__k98EL`,
	"radioContainer": `ZakupiteljChoice_radioContainer__YUBJS`,
	"radioInput": `ZakupiteljChoice_radioInput__z54Ln`,
	"radioRowContainer": `ZakupiteljChoice_radioRowContainer__Mz+RO`
};
export default ___CSS_LOADER_EXPORT___;
